
export const dspDistributionListingConstants = {
    CLEAR_ALL_MESSAGE: 'CLEAR_ALL_MESSAGE',
    GETALLDISTRIBUTIONLISTING_REQUEST: 'GETALLDISTRIBUTIONLISTING_REQUEST',
    GETALLDISTRIBUTIONLISTING_REQUEST_END: 'GETALLDISTRIBUTIONLISTING_REQUEST_END',
    GETALLDISTRIBUTIONLISTING_SUCCESS: 'GETALLDISTRIBUTIONLISTING_SUCCESS',
    GETALLDISTRIBUTIONLISTING_FAILURE: 'GETALLDISTRIBUTIONLISTING_FAILURE'
};

